import type { SVGProps } from "react";

export default function EyeIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      height={20}
      width={20}
      {...props}
    >
      <path
        d="M8.33463 18.3333C5.19194 18.3333 3.62059 18.3333 2.64428 17.357C1.66797 16.3807 1.66797 15.6427 1.66797 12.5"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M18.3307 12.5C18.3307 15.6427 18.3307 16.3807 17.3544 17.357C16.3781 18.3333 14.8067 18.3333 11.6641 18.3333"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M11.6641 1.66699C14.8067 1.66699 16.3781 1.66699 17.3544 2.6433C18.3307 3.61962 18.3307 4.35763 18.3307 7.50033"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M8.33463 1.66699C5.19194 1.66699 3.62059 1.66699 2.64428 2.6433C1.66797 3.61962 1.66797 4.35763 1.66797 7.50033"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M4.91166 11.7172C4.41587 11.1421 4.16797 10.8545 4.16797 10.0007C4.16797 9.14682 4.41586 8.85923 4.91165 8.28416C5.90161 7.13583 7.56187 5.83398 10.0013 5.83398C12.4407 5.83398 14.101 7.13583 15.091 8.28416C15.5867 8.85923 15.8346 9.14682 15.8346 10.0007C15.8346 10.8545 15.5867 11.1421 15.091 11.7172C14.101 12.8655 12.4407 14.1673 10.0013 14.1673C7.56187 14.1673 5.90162 12.8655 4.91166 11.7172Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M9.9987 11.6663C10.9192 11.6663 11.6654 10.9201 11.6654 9.99967C11.6654 9.0792 10.9192 8.33301 9.9987 8.33301C9.07822 8.33301 8.33203 9.0792 8.33203 9.99967C8.33203 10.9201 9.07822 11.6663 9.9987 11.6663Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
    </svg>
  );
}
